module.exports = __webpack_public_path__ + "static/media/slider-small-1.107ecdfd.jpg";